export default __webpack_public_path__ + "static/media/Groupe 200.e44f79d6.svg";